import { createStringTemplate } from '@/templating';

export const renderCancellationPolicyBody = createStringTemplate<{
  infoEmailAddress: string | undefined;
}>();
